module.exports = __webpack_public_path__ + "img/02-01-img-03.7487c136.png";